import styled, { keyframes } from "styled-components";

export const StyledFooter = styled.section`
    padding: 0;
    margin: 0;
    width: 100%;
    display: inline;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  Imagefooter = styled.img`
 
  @media only screen and (min-width: 320px) and (max-width: 600px) {
    height: 140px !important;
  }
  
`,
  FooterBox = styled.div`
    padding: 0;
    margin: 0;
    display: inline;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-flow: column;
    @media only screen and (min-width: 600px) {
      flex-flow: row;
      align-items: flex-end;
    } ;
  `,
  TextBox = styled.div`
    padding: 0;
    margin: 0;
    display: flex;
    align-self: flex-start;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0;
    @media only screen and (min-width: 600px) {
      justify-content: flex-end;
      padding-bottom: 1.5vw;
      // width: 45%;
    } ;
  `,
  FinePrint = styled.p`
    padding: 0;
    margin: 0;
    font-weight: 300;
    color: #444444;
    width: 75%;
    font-size: 12px;
    line-height: 2;
    text-align: center;
    padding: 2vw 0vw;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    @media only screen and (min-width: 320px) and (max-width: 375px){
      font-size: 11px;
    }
    @media only screen and (min-width: 600px){
      padding: 1vw 0vw;
      line-height: 1.8;
      text-align: left;
      font-size: 1.5vw;
    }
    @media only screen and (min-width: 1000px) {
      line-height: 2.3;
      text-align: left;
      font-size: 0.9vw;
    } ;
  `,
  FinerPrint = styled(FinePrint)`
    padding: 0;
    margin: 0;
    display: none;
    @media only screen and (min-width: 600px) {
      display: initial;
      width: 70%;
      font-size: 9px;
      text-align: center;
      font-size: 1.1vw;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 0.8vw;
    }
  `,
  MobileFinerPrint = styled(FinePrint)`
    padding: 0;
    margin: 0;
    width: 70%;
    font-size: 9px;
    @media only screen and (min-width: 600px) {
      display: none;
    }
  `,
  LogoBox = styled.div`
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    padding: 5vw 0vw 5vw 1vw;
    flex-flow: row wrap;
    height: 100%;
    @media only screen and (min-width: 600px) {
      flex-flow: column nowrap;
      // width: calc(35% - 1vw);
      align-items: flex-end;
      padding: 0;
    }
    @media only screen and (min-width: 320px) and (max-width: 599.7px) {
      padding: 5vw 0vw 18vw 1vw !important;
    }
  `,
  LogoRow = styled.div`
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
    padding: 1vw 0vw;
    @media only screen and (min-width: 600px) {
      // justify-content: flex-start;
      padding: 0;
    }
  `,
  Logo = styled.img`
    padding: 0;
    height: 15vw;
    margin: 0.05vw 1vw;
    @media only screen and (min-width: 600px) {
      height: 6.25vw;
    }
    @media only screen and (min-width: 1000px) {
      height: 4.5vw;
    }
  `,
  TallLogo = styled(Logo)`
    height: 10vw;
    position:relative;
    top:-2vw;
    left:-1vw;
    @media only screen and (min-width: 320px) and (max-width: 350.7px)  {
      height: 23.25vw;
      left: -26vw;
      top: 28.5vw;
    }
    @media only screen and (min-width: 350px) and (max-width: 599.7px)  {
    height: 18.75vw;
    left: -29vw;
      top: 28.5vw;
    }
    @media only screen and (min-width: 600px) and (max-width: 999.7px)  {
      height: 8.25vw;
      top:0.5vw;
    }
    @media only screen and (min-width: 1000px) {
      height: 5vw;
    } ;
  `,
  Top50Logo = styled(Logo)`
    height: 10vw;
    position:relative;
    left:-1vw;
    top:-4.9vw;
    @media only screen and (min-width: 320px) and (max-width: 599.7px)  {
      height: 29.25vw;
      top: -20vw;
      left: 35vw;
    }
    @media only screen and (min-width: 600px) and (max-width: 999.7px) {
      height: 19.25vw;
    }
    @media only screen and (min-width: 1000px) {
      height: 12vw;
    } ;
  `,
  FooterLogo = styled(Logo)`
    height: 10vw;
    position:relative;
    left:-1vw;
    top:-5vw;
    @media only screen and (min-width: 320px) and (max-width: 599.7px)  {
      height: 29.25vw;
      top: -20.5vw;
      left: 35vw;
    }
    @media only screen and (min-width: 600px) and (max-width: 999.7px) {
      height: 19.25vw;
    }
    @media only screen and (min-width: 1000px) {
      height: 12vw;
    } ;
  `,
  LogoFooter = styled(Logo)`
  height: 10vw;
  position:relative;
  left:8vw;
  margin-bottom:-1vw;
  @media only screen and (min-width: 320px) and (max-width: 599.7px)  {
    height: 19.25vw;
    left: 0vw;
    top: 32.5vw;
  }
  @media only screen and (min-width: 600px) and (max-width: 999.7px) {
  height: 8.25vw;
  left:12vw;
  top:3vw;
  }
  @media only screen and (min-width: 1000px) {
    height: 5vw;
  } ;
`,
  FooterNav = styled.nav`
    padding: 0;
    margin: 0;
    width: calc(100%);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: row wrap;
    font-family:Montserrat;
    padding: 0vw 8vw 4vw 4vw;
    @media only screen and (min-width: 600px) {
      flex-flow: row nowrap;
      width: calc(100%);
      margin: -4vw 0vw 0vw 0vw;
      padding: 2vw 0vw;
    }
  `,
  NavLink = styled.a`
    padding: 0;
    margin: 0;
    border-right: ${({ side = "normal" }) =>
      side === "right" ? "0px" : "2px solid #DDDDDD"};
    padding: 0.25rem;
    text-decoration: none;
    @media only screen and (min-width: 600px) {
      padding: 0.5vw;
    }
  `,
  NavText = styled.p`
    padding: 0;
    margin: 0;
    color: #444444;
    font-weight: 400;
    font-size: 3vw;
    @media only screen and (min-width: 600px) {
      font-size: 1vw;
      white-space: nowrap;
    }
  `,
  CopyrightBar = styled(FooterNav)`
    padding: 0;
    margin: 0;
    width: 100%;
    background: #083f88;
    @media only screen and (min-width: 600px) {
      padding: 3px;
      width: calc(100%);
      justify-content: space-around;
    }
  `,
  CopyrightText = styled.p`
    padding: 0;
    margin: 0;
    color: #ffffff;
    font-size: 12px;
    line-height:1.5;
    width: 100%;
    font-weight: 100;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    @media only screen and (min-width: 600px) {
      font-size: 1.2vw;
      padding: 0.1rem 3vw 0.1rem 3rem;
    }
  `,
  Link = styled.a`
    padding: 0;
    margin: 0;
    text-decoration: none;
    color: #00aae4;
    cursor: pointer;
  `,
  LuckBox = styled.div`
    padding: 0;
    margin: 0;
    width: 100%;
    padding: 2vw 0vw;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    @media only screen and (max-width: 599px) {
      display:none;
    }
  `,
  expand = keyframes`
0%{width:0%;}
100%{width:33%;}
`,
  appear = keyframes`
0%{opacity:0; transform:translateY(100%);}
70%{opacity:0.5;}
100%{opacity:1;transform:translateY(0%);}
`,
  LuckLine = styled.div`
    padding: 0;
    margin: 0;
    border: 1px solid rgb(95, 95, 95, 0.5);
    width: 33%;
    background: rgb(95, 95, 95, 0.5);
    margin: 0vw 4vw;
    border-radius: 10px;
    box-shadow: 0px 15px 40px rgba(95, 95, 95, 0.2);
    animation: ${expand} 0.7s ease-out 0s 1;
    @media only screen and (min-width: 600px) {
      margin: 0vw 2vw;
    }
  `,
  WishLuck = styled.a`
    padding: 0;
    margin: 0;
    text-decoration: none;
    padding: 1.5vw 1.5vw 1vw 1.5vw;
    border: 2px solid rgb(88, 88, 88, 0.5);
    border-radius: 30px;
    color: rgb(95, 95, 95);
    font-size: 14px;
    animation: ${appear} 0.7s ease-out 0s 1;
    white-space: nowrap;
  `,
  StandIn = styled.div`
    padding: 0;
    margin: 0;
    width: 100%;
    height: 6vw;
  `,
  ToolTip = styled.div`
    padding: 0;
    margin: 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    font-size: 10px;
    text-overflow: ellipsis;
    color: rgb(88, 88, 88);
    z-index: 4;
    margin-left: -3px;
  `,
  ToolBox = styled.div`
    padding: 0;
    margin: 0;
    &:before {
      content: "";
      z-index: 3;
      margin-left: -5px;
      width: 8px;
      height: 8px;
      transform: rotate(-45deg);
      background: white;
      border-top: 1px solid rgb(88, 88, 88);
      border-left: 1px solid rgb(88, 88, 88);
      border-bottom: 1px solid white;
      border-right: 1px solid white;
    }
    display: none;
  `,
  HoverBox = styled.div`
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &:hover ${ToolBox} {
      display: flex;
      position: absolute;
      justify-content: center;
      align-items: center;
      border: 1px solid rgb(88, 88, 88);
      z-index: 2;
      padding: 0.35rem 0.25rem 0.25rem 0vw;
      border-radius: 3px;
      text-overflow: ellipsis;
      background: white;
      margin-left: ${({ left }) => left}vw;
    }
    @media only screen and (min-width: 600px) {
      &:hover ${ToolBox} {
        margin-left: ${({ left }) => left * 0.45}vw;
      }
    }
    @media only screen and (min-width: 1000px) {
      &:hover ${ToolBox} {
        margin-left: ${({ left }) => left * 0.33}vw;
      }
    }
  `,
  HoverBoxBird = styled.div`
    padding: 0;
    margin-top:20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &:hover ${ToolBox} {
      display: flex;
      position: absolute;
      justify-content: center;
      align-items: center;
      border: 1px solid rgb(88, 88, 88);
      z-index: 2;
      padding: 0.35rem 0.25rem 0.25rem 0vw;
      border-radius: 3px;
      text-overflow: ellipsis;
      background: white;
      margin-left: ${({ left }) => left}vw;
    }
    @media only screen and (min-width: 600px) {
      &:hover ${ToolBox} {
        margin-left: ${({ left }) => left * 0.45}vw;
      }
    }
    @media only screen and (min-width: 1000px) {
      &:hover ${ToolBox} {
        margin-left: ${({ left }) => left * 0.33}vw;
      }
    }
    height: 10vw;
    position:relative;
    top:-2vw;
    left:-1vw;
    @media only screen and (min-width: 320px) and (max-width: 599.7px)  {
      height: 10vw;
      left: -26vw;
      top: 28.5vw;
    }
    @media only screen and (min-width: 600px) and (max-width: 999.7px)  {
      height: 8.25vw;
      top:0.5vw;
    }
     
  `,
  Iframe = styled.div`
  @media only screen and (min-width: 320px) and (max-width: 599.7px)  {
    width: 130px;
    height: 75px;
  }
  @media only screen and (min-width: 600px) and (max-width: 999.7px)  {
    height: 8.25vw;
    top:0.5vw;
  }

  `,
  SocialIconBox = styled.div`
    display: flex;
    width: calc(100% - 5%);
    justify-content: center;
    align-items: center;
    padding: 0.25vw 2.5%;
    @media only screen and (max-width: 599px) {
    display:none;
    }
  `
;
